import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import React from "react";

export default observer(function ChatReplyScrollingLoader() {
	const rootStore = useRootAppStore();

	if (!rootStore.chatViewStore.replyScrollingLoader) {
		return null;
	}

	return (
		<div className="chat__loader loader--circle">
			<div className="loader--circle__spinner">
				<div />
				<div />
				<div />
			</div>
		</div>
	);
});
